import React from "react";
import { useLanguage } from "../../context/LanguageContext";
import { seo } from "../../translations/seo";

const HERO_IMG = "/images/hero.jpg";

export default function Hero() {
  const { t, language } = useLanguage();
  return (
    <section id="home" className="relative overflow-hidden" data-testid="hero-section">
      <h1 className="sr-only" data-testid="home-h1">{seo[language].home.title.replace(" |", " –")}</h1>
      <div className="relative">
        <img
          src={HERO_IMG}
          alt="Centre Médical Psymed"
          className="w-full h-auto object-cover block"
          data-testid="hero-image"
        />
        <div className="absolute inset-x-0 bottom-6 sm:bottom-10 flex justify-center px-6 z-10">
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 animate-fade-in-up anim-delay-200">
            <a
              href="#services"
              className="gradient-bg text-white font-semibold px-7 sm:px-8 py-3.5 sm:py-4 rounded-full hover:opacity-90 transition-opacity shadow-lg shadow-blue-900/30"
              data-testid="hero-services-btn"
            >
              {t.hero.cta_services}
            </a>
            <a
              href="#contact"
              className="bg-white text-[#2E4DB5] font-semibold px-7 sm:px-8 py-3.5 sm:py-4 rounded-full border border-slate-200 hover:border-[#2E4DB5] hover:bg-slate-50 transition-colors shadow-lg shadow-blue-900/10"
              data-testid="hero-contact-btn"
            >
              {t.hero.cta_contact}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
